/**
 * Stable card slots. A mission that leaves the view frees its slot, and the
 * next mission of the same kind reuses it, so React keeps the card mounted.
 */

export function cardKind(task) {
  const kind = task?.nodeType;
  if (kind === 'decision' || kind === 'milestone' || kind === 'note') return kind;
  return 'task';
}

export function createCardSlotPool() {
  return {
    nextId: 1,
    slots: new Map(),
    taskToSlot: new Map(),
  };
}

export function assignCardSlots(pool, tasks) {
  const wanted = [];
  const seen = new Set();
  (tasks || []).forEach((task) => {
    if (!task || seen.has(task.id)) return;
    seen.add(task.id);
    wanted.push(task);
  });

  const kept = new Set();
  const incoming = [];
  wanted.forEach((task) => {
    const slotId = pool.taskToSlot.get(task.id);
    const slot = slotId ? pool.slots.get(slotId) : null;
    if (slot && slot.taskId === task.id && slot.kind === cardKind(task)) {
      kept.add(slotId);
      return;
    }
    incoming.push(task);
  });

  const freeByKind = new Map();
  pool.slots.forEach((slot, slotId) => {
    if (kept.has(slotId)) return;
    pool.taskToSlot.delete(slot.taskId);
    const list = freeByKind.get(slot.kind) || [];
    list.push(slotId);
    freeByKind.set(slot.kind, list);
  });

  incoming.forEach((task) => {
    const kind = cardKind(task);
    const free = freeByKind.get(kind);
    const reused = free && free.length ? free.pop() : null;
    const slotId = reused || `card-slot-${pool.nextId++}`;
    const previous = pool.slots.get(slotId);
    if (previous) pool.taskToSlot.delete(previous.taskId);
    pool.slots.set(slotId, { taskId: task.id, kind });
    pool.taskToSlot.set(task.id, slotId);
    kept.add(slotId);
  });

  freeByKind.forEach((ids) => {
    ids.forEach((slotId) => {
      pool.slots.delete(slotId);
    });
  });

  const taskById = new Map(wanted.map((task) => [task.id, task]));
  const assigned = [];
  pool.slots.forEach((slot, slotId) => {
    const task = taskById.get(slot.taskId);
    if (task) assigned.push({ slotId, task });
  });
  return assigned;
}
